import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { isEligibleTenant } from '../../utilities/roles';
import { shouldLoadOnboarding } from '../../utilities/requirements';
import { DataStorage } from '../../utilities/storage';
import { FormattedMessage } from 'react-intl';
import { beginsWith } from '../../utilities/string';

class AuthenticatedRoute extends React.Component {
    componentDidMount() {
        const { job, role, setMenuLabelOfLocation } = this.props;

        if (!role || !job) {
            return;
        }

        if (role.type === 'contractor' && job.pay_type !== 'h') {
            setMenuLabelOfLocation('/time', <FormattedMessage id={'invoicing'} defaultMessage={'Invoicing'} />);
        }
    }

    render() {
        const { component: Component, ...rest } = this.props;
        return (
            <Route
                {...rest}
                render={props => {
                    const { isAuthenticated, role, navigablePages, tenants, requirements, details, job } = rest;

                    if (isAuthenticated !== true) {
                        DataStorage.clear();
                        return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />;
                    }

                    // Enforcing onboarding if needed
                    let isOnOnboarding = props.location && props.location.pathname && beginsWith(props.location.pathname, '/onboarding');
                    let shouldOnboard;

                    switch (role.type) {
                        case 'client':
                            shouldOnboard = details.status !== 'active' && details.status !== 'submitted';
                            break;

                        case 'i9':
                            shouldOnboard = true;
                            break;
                        case 'contractor':
                            if (job.progress) {
                                if (
                                    job.progress.branch === 'ic-continue-request' ||
                                    job.progress.branch === 'dont-know' ||
                                    job.progress.branch === 'dont-qualify-ic'
                                ) {
                                    shouldOnboard = false;
                                } else {
                                    shouldOnboard = shouldLoadOnboarding(requirements);
                                }
                            } else {
                                shouldOnboard = shouldLoadOnboarding(requirements);
                            }
                            break;
                        default:
                            shouldOnboard = shouldLoadOnboarding(requirements);
                    }

                    if (shouldOnboard && !isOnOnboarding) {
                        return <Redirect to={{ pathname: '/onboarding', state: { from: props.location } }} />;
                    }

                    // Redirecting from onboarding if complete
                    if (!shouldOnboard && isOnOnboarding) {
                        return <Redirect to={{ pathname: '/', state: { from: props.location } }} />;
                    }
                    if (isEligibleTenant(role, tenants, navigablePages, props.location.pathname) === true) {
                        return <Component {...props} {...rest} />;
                    }

                    return <Redirect to={{ pathname: '/', state: { from: props.location } }} />;
                }}
            />
        );
    }
}

export default AuthenticatedRoute;



// WEBPACK FOOTER //
// ./src/components/routes/authenticated.jsx